import { morph } from '@theme/morph';
import { ThemeEvents } from '@theme/events';

/**
 * Updates ShopLC HTML section body when the product variant changes (metafield-driven HTML).
 * Relies on the variant picker's section fetch, which re-renders the page with the selected variant.
 */
class ShoplcHtmlComponent extends HTMLElement {
  /** @param {Event} event */
  #onVariantUpdate = (event) => {
    if (this.dataset.variantSync !== 'true') return;

    const payload = event.detail?.data;
    if (!payload?.html) return;

    if (payload.newProduct?.id) {
      this.dataset.productId = payload.newProduct.id;
    } else if (payload.productId && this.dataset.productId && payload.productId !== this.dataset.productId) {
      return;
    }

    const sectionId = this.dataset.shoplcSectionId;
    if (!sectionId) return;

    const doc = payload.html;
    const newWrapper = doc.getElementById(`shopify-section-${sectionId}`);
    const currentContent = this.querySelector('.section-shoplc-html__content');
    if (!currentContent) return;

    const sectionRoot = this.closest('.shopify-section');

    if (!newWrapper) {
      sectionRoot?.setAttribute('hidden', '');
      return;
    }

    sectionRoot?.removeAttribute('hidden');

    const newContent = newWrapper.querySelector('.section-shoplc-html__content');
    if (!newContent) {
      currentContent.replaceChildren();
      return;
    }

    morph(currentContent, newContent);
  };

  connectedCallback() {
    if (this.dataset.variantSync !== 'true') return;
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }
}

if (!customElements.get('shoplc-html-component')) {
  customElements.define('shoplc-html-component', ShoplcHtmlComponent);
}
